import { LoadingButton } from '@mui/lab';
import { Box, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import { useState } from 'react';
import { toast } from 'react-toastify';
import Iconify from 'src/components/Iconify';
import useAuth from 'src/hooks/useAuth';

export function SuccessModal({ event, response, onClose }) {
  const [loading, setLoading] = useState(false);

  const { silent_login } = useAuth();

  const loginToEvent = async (event_code, id) => {
    if (window.confirm("Click 'Ok' to switch to event dashboard (this will log you out of your client dashboard).")) {
      setLoading(true);

      try {
        await silent_login(event_code);
      } catch (err) {
        toast.error(err?.message);
      }
    }
  };

  return (
    <Dialog
      onClose={onClose}
      open
      maxWidth="sm"
      fullWidth
      scroll="body"
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <>
        <Iconify
          icon={'akar-icons:circle-check'}
          style={{ margin: '40px auto 10px', display: 'block' }}
          color={'#00AB55'}
          width={62}
          height={62}
        />
        <DialogTitle id="alert-dialog-title" sx={{ mt: 1, m: '10px auto 0px', textAlign: 'center' }}>
          {response ? ' Event created successfully!' : 'Event links'}
        </DialogTitle>
        <DialogContent>
          <DialogContentText sx={{ lineHeight: 1.9, mt: 1, mb: 0, textAlign: 'center' }}>
            Find your event links and details below.
            <Box sx={{ p: 2, textAlign: 'left', my: 2, border: '1px dashed #eee', background: '#f8f8f8' }}>
              <b>Virtual event link: </b>
              {'  '}
              <a target="_blank" href={'https://arsh.events/' + event + ''}>
                https://arsh.events/{event}
              </a>{' '}
              <br /> <b>Registration link:</b>
              {'  '}
              <a target="_blank" href={'https://arsh.events/' + event + '/register'}>
                https://arsh.events/{event}/register
              </a>
              <br /> <b>Login link:</b>
              {'  '}
              <a target="_blank" href={'https://arsh.events/' + event + '/register'}>
                https://arsh.events/{event}/login
              </a>
              <br /> <b>Speaker's registration:</b>
              {'  '}
              <a target="_blank" href={'https://arsh.events/' + event + '/register/speaker'}>
                https://arsh.events/{event}/register/speaker
              </a>{' '}
              <br /> <b>Self check-in link:</b>
              {'  '}
              <a target="_blank" href={'https://arsh.events/' + event + '/register/check-in'}>
                https://arsh.events/{event}/check-in
              </a>
              <br /> <b>Upgrade reg. package:</b>
              {'  '}
              <a target="_blank" href={'https://arsh.events/' + event + '/register/modify'}>
                https://arsh.events/{event}/register/modify
              </a>
              <br />
              <br /> <b>Admin Details</b>
              <br /> <b>Admin Login URL:</b>
              {'  '}
              <a target="_blank" href={'https://arsh.events/' + event + '/admin'}>
                https://arsh.events/{event}/admin
              </a>{' '}
              {response && (
                <>
                  <br /> <b>Username: </b>
                  {'  '}
                  {response?.adminDetails?.username}
                  <br />
                  <b>Password: </b>
                  {'  '}
                  {response?.adminDetails?.password}
                  <br />
                </>
              )}
            </Box>
            {response && <p>Your event details has also been emailed to you.</p>}
          </DialogContentText>
        </DialogContent>

        <DialogActions sx={{ justifyContent: 'center' }}>
          {response && (
            <LoadingButton
              loading={loading}
              onClick={() => {
                setLoading(true);
                loginToEvent(event);
              }}
              variant="contained"
            >
              Enter event dashboard
            </LoadingButton>
          )}

          <LoadingButton
            loading={loading}
            onClick={() => {
              onClose ? onClose() : (window.location.href = '');
            }}
            variant="text"
          >
            Go Back
          </LoadingButton>
        </DialogActions>
      </>
    </Dialog>
  );
}
